<template>
  <ul>
    <li v-for = "(message, i) in messages" v-bind:key = "i" >{{message}}</li>
  </ul>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Log',
  data () {
    return {
      test: false
    }
  },
  computed: {
    ...mapState([
      'messages'
    ])
  },
  methods: {
    ...mapActions([
      'clearmessages'
    ])
  }
}
</script>
